import React, { Component } from 'react';

import { Button } from 'react-bootstrap';
import FilePreview from './FilePreview';
import plusIcon from '../../assets/images/plus-circle.png';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';

class FileUpload extends Component {
  state = {
    fileList: [],
    hoverState:''
  };

  /**
  * @desc handling draging file in file upload
  * @param event
  * @return null
  */
  handleDragOver = (e) =>  {
    if ('preventDefault' in e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const hoverState = (e.type === 'dragover') ? "hover" : null;
    this.setState({
      hoverState
    })
  }

  /**
  * @desc handling file select event in file upload
  * @param event
  * @return null
  */
  handleFileSelect = (e) => {
    // ConsoleLog("handleselct")
    this.handleDragOver(e);
    let files = e.target.files || e.dataTransfer.files;
    let fileList = Object.keys(files).map(file => files[file]);    
    let file = (fileList.length > 0 && fileList[0]) ? fileList[0] : null;
    let errorMessage = "";
    if(file && (file.size > this.props.maxSize)) {
      errorMessage = "File size exceeded.";
      fileList = [];
      file = null;
    }
    this.props.handleFileSelect(file, errorMessage);
    this.setState({
      fileList
    });
  }

  /**
  * @desc Removing the selected file.
  * @param index
  * @return null
  */
  removeItem = (index) => {
    let fileList = this.state.fileList;
    fileList.splice(index,1);
    let file = (fileList.length > 0 && fileList[0]) ? fileList[0] : null;
    this.props.handleFileSelect(file);
    this.setState({
      fileList
    });
  }

  removeFile = ()=> {
    // ConsoleLog("removeFile")
    this.setState({
      fileList:[]
    });
  }

  /**
  * @desc preview for the file upload.
  * @param null
  * @return null
  */
  previews = () => {
    return this.state.fileList.map((file, index) => {
      return (
        <FilePreview key={index} data={file} onRemove={this.removeItem} />
      );
    });
  }

  /**
  * @desc Selecting the file to be uploaded
  * @param event
  * @return null
  */
  selectFile = (e) => {
    e.preventDefault();
    this.input.click(e);
  }

  /**
  * @desc Rendering the DOM element 
  * @param null
  * @return DOM element
  */
  render() {
    let {
      maxSize,
      name,
      multiple,
      label,
      acceptedTypes,
      candidateImageUpload
    } = this.props;

    const buttonText = (candidateImageUpload ? "Browse" : "Add Photo")

    let dragClasses = (this.state.fileList.length > 0 && !candidateImageUpload) ? "file-drag dropzone-file-added" : "file-drag";

    return (
      <div className="File-Upload-Container">
          <input type='hidden' name={`${name}:maxSize`} value={maxSize} />
          <div>
            <div className={dragClasses}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragOver}
                onDrop={this.handleFileSelect}>                
              <div className="dropzone-message">
                <span>
                  <span className="dropzone-text">Drop Your Photo Here</span>
                  <br/>
                  {(candidateImageUpload && this.state.hoverState)?"":<span className="dropzone-text-italic"> Or </span>}
                </span>
              </div>              
              {candidateImageUpload?"":<div className="dropzone-preview">{this.previews()}</div>}
            </div>
            <div className="upload-button-input">
              <input 
                type='file'
                tabIndex='-1'
                ref={x => this.input = x}
                className="input-file-upload"
                name={name} 
                multiple={multiple}
                size={maxSize}
                accept={acceptedTypes}
                onChange={this.handleFileSelect}
                onClick={(e)=> { e.target.value = null }}/>

              <Button 
                className={candidateImageUpload ? this.state.hoverState?"recruiter-attach-photo-button-hide":"recruiter-attach-photo-button" : "client-attach-photo-button"}
                type='button'
                onClick={this.selectFile}>
                <img 
                  className="plus-icon" 
                  src={plusIcon} 
                /> 
                {buttonText}
              </Button>
            </div>
          </div>
          
      </div>
    );
  }
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/hoc/FileUpload/FileUpload.js